var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-btn',{attrs:{"icon":"","to":{
    name: 'dashboard-action-collection',
    params: {
      actionId: _vm.actionId,
      actionResultKey: _vm.actionResultKey
    }
  }}},[_c('v-icon',[_vm._v("fa-eye")])],1)}
var staticRenderFns = []

export { render, staticRenderFns }